import { shellStringResources } from '../../Resources/ShellStringResources';
import { Constants } from '../../shared/shared-constants';
import { IModel, Collection, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { TriggerProperties } from './trigger-properties';

export type TriggerEvent = 'Microsoft.Storage.BlobCreated' | 'Microsoft.Storage.BlobDeleted';
@Metamodel.model({
    name: 'BlobEventsTrigger',
    display: [shellStringResources.ModelName_StorageEvents, shellStringResources.ModelName_StorageEventTriggers],
    validator: EventTriggerProperties.prototype.validate
})
export class EventTriggerProperties extends TriggerProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Scope,
        constraint: {
            required: true
        }
    })
    public scope: string;

    // for fabric
    @Metamodel.attribute({
        constraint: {
            required: false
        }
    })
    public dmtsConnectionId?: string;

    // for fabric
    @Metamodel.attribute({
        constraint: {
            required: false
        }
    })
    public storageAccountName?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Tenant,
        constraint: {
            required: false
        }
    })
    public tenantId: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_BlobPathBeginsWith,
        constraint: {
            required: false,
            pattern: Constants.startsWithValidation
        }
    })
    public blobPathBeginsWith?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_BlobPathEndsWith,
        constraint: {
            required: false,
            pattern: Constants.endsWithValidation
        }
    })
    public blobPathEndsWith?: string;

    @Metamodel.attribute({
        display: shellStringResources.Trigger_Event,
        collection: Collection.Array,
        constraint: {
            minOccurs: 1,
            unique: true
        }
    })
    public events: TriggerEvent[] = [];

    @Metamodel.attribute({
        display: shellStringResources.Trigger_IgnoreEmptyBlobs
    })
    public ignoreEmptyBlobs: boolean;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_MaxConcurrency,
        constraint: {
            required: false,
            maximum: 50,
            minimum: 1,
            whole: true
        }
    })
    public maxConcurrency?: number;

    public validate(): IViolation[] | undefined {
        if (!this.blobPathBeginsWith && !this.blobPathEndsWith) {
            return [{
                message: () => shellStringResources.EventTriggerValidationMessage
            }];
        }
        if (!Constants.storageScopeValidation.test(this.scope)) {
            return [{
                message: () => shellStringResources.Trigger_EventInvalidScopeFormat
            }];
        }
        return undefined;
    }
}
